"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DnsProvider = void 0;
var DnsProvider;
(function (DnsProvider) {
    DnsProvider["CLOUDFLARE"] = "cloudflare";
})(DnsProvider = exports.DnsProvider || (exports.DnsProvider = {}));
